import React from 'react';
import {Box, Stack, Typography} from "@mui/material";
import {formatCurrency} from "../../utils/helpers";

const TotalRecapMobileView = (props) => {
    const totalHT = props.total.totalHT;
    const totalTTC = props.total.totalTTC;
    const totalTVA = totalTTC - totalHT;
    const depositAmount = props.depositAmount ? props.depositAmount : (props.depositPercentage ? (props.depositPercentage / 100) * totalTTC : 0);

    return (
        <Box sx={{
            mt: 2,
            p: 1,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        }}>
            <Typography variant="h6" gutterBottom>Total de la réservation</Typography>
            <Stack direction="row" justifyContent="space-between">
                <Typography>Total HT :</Typography>
                <Typography>{formatCurrency(totalHT)}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Typography>Total TVA :</Typography>
                <Typography>{formatCurrency(totalTVA)}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Typography sx={{fontWeight: "bold"}}>Total TTC :</Typography>
                <Typography sx={{fontWeight: "bold"}}>{formatCurrency(totalTTC)}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Typography>Acompte :</Typography>
                <Typography>{formatCurrency(depositAmount)}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
                <Typography>Solde :</Typography>
                <Typography>{formatCurrency(totalTTC - depositAmount)}</Typography>
            </Stack>
        </Box>
    )
}

export default TotalRecapMobileView;